// 数据相关接口
import request from '@/utils/request'

//************************模板分类
//分页查询模板分类列表
export function fileItemList(query) {
	return request({
		url: '/biz/fileType/list',
		method: 'get',
		params: query
	})
}

//新增模板分类
export function addType(data) {
	return request({
		url: '/biz/fileType/add',
		method: 'post',
		data: data
	})
}

//编辑模板分类
export function editType(data) {
	return request({
		url: '/biz/fileType/edit',
		method: 'put',
		data: data
	})
}

//删除模板分类
export function delType(params) {
	return request({
		url: '/biz/fileType/remove',
		method: 'delete',
		params
	})
}

//************************模板文件
//新增模板文件
export function addFile(data) {
	return request({
		url: '/biz/file/add',
		method: 'post',
		data: data
	})
}

//=======================赛季模块
// 查询赛事类型列表
export function gameTypeList(query) {
	return request({
		url: '/biz/type/list',
		method: 'get',
		params: query
	})
}

//查询赛事列表
export function gameList(query) {
	return request({
		url: '/biz/match/list',
		method: 'get',
		params: query
	})
}

//分页查询模板文件列表
export function fileList(query) {
	return request({
		url: '/biz/file/pageList',
		method: 'get',
		params: query
	})
}

//编辑模板文件
export function editFile(data) {
	return request({
		url: '/biz/file/edit',
		method: 'put',
		data: data
	})
}

//文件启用——禁用
export function switchType(data) {
	return request({
		url: `/biz/file/updateIsEnable`,
		method: 'put',
		params: data
	})
}

//删除模板文件
export function delFile(params) {
	return request({
		url: '/biz/file/remove',
		method: 'delete',
		params
	})
}


//查询赛事类型下拉列表
export function typeList(query) {
	return request({
		url: '/biz/type/selectList',
		method: 'get',
		params: query
	})
}

//查询赛事项目下拉列表
export function itemList(query) {
	return request({
		url: '/biz/item/selectList',
		method: 'get',
		params: query
	})
}

//查询模板分类下拉列表
export function fileTypeList(query) {
	return request({
		url: '/biz/fileType/selectList',
		method: 'get',
		params: query
	})
}

